import { lazy } from 'react'

/**
 * Módulo: Comunicaciones
 * Mensajería, conversaciones, difusiones, acciones embebidas.
 */
export default {
  id: 'comunicaciones',
  nombre: 'Comunicaciones',
  descripcion: 'Mensajería en tiempo real, difusiones y acciones embebidas',
  icono: 'message-square',
  tipo: 'core',
  version: '1.0.0',
  // Mensajes visible para todos los roles

  routes: [
    { path: 'mensajes', component: lazy(() => import('./pages/MensajesPage')) },
    { path: 'difusiones', component: lazy(() => import('./pages/DifusionesPage')) },
  ],

  // #87 — `permisoModulo` filtra item-by-item según el rol.
  // "Mensajes" se mudó al grupo GESTIÓN (gestion/config.js) el 6-jul — es la
  // bandeja PERSONAL del usuario y vive junto a Mis actividades. La ruta
  // /mensajes sigue acá (routes); los roles cliente usan el Portal.
  // "Difusiones" se mudó al grupo PLATAFORMA OPERACIÓN
  // (plataforma-operacion/config.js) el 7-jul — la ruta /difusiones sigue acá
  // (routes), solo se movió el ítem del menú. Sin ítems propios, el grupo
  // COMUNICACIONES ya no aparece en el sidebar.
  menuItems: [],

  features: [
    'conversaciones',
    'difusiones',
    'acciones-embebidas',
    'mensajes-programados',
  ],

  // permisoModulos (#58): se deriva del rol.
  // Incluye el código de cada ítem del menú cuya ruta monta este módulo: lo exige `src/core/lib/menuRutaPermiso.guard.test.js`.
  permisoModulos: ['mensajes', 'difusiones'],

}
